const initialState = {
  treeData: [],
  loading: false,
  error: null,
  rawObjectives: [],
  associatedTeams: [],
};

export default initialState;
